@let stepper = wizard();
@let blocked = disableWhenInvalid() && !stepper.canProceed();

@if (!stepper.isFirst()) {
  <button
    type="button"
    procure-button
    variant="stroked"
    [disabled]="finishLoading() || isAdvancing()"
    (click)="stepper.previous()"
  >
    {{ backLabel() }}
  </button>
}

<span class="spacer"></span>

<ng-content />

@if (stepper.isLast()) {
  <button
    type="button"
    procure-button
    color="primary"
    [disabled]="blocked"
    [loading]="finishLoading()"
    (click)="complete()"
  >
    {{ finishLabel() }}
  </button>
} @else {
  <button
    type="button"
    procure-button
    color="primary"
    [disabled]="blocked"
    [loading]="isAdvancing()"
    (click)="goToNext()"
  >
    {{ nextLabel() }}
  </button>
}
